
  export default {
    isValidPhoneNumber: function (phone) {
        // 공백, 하이픈 제거
        const cleaned = phone.replace(/[\s-]/g, '');
      
        // 정규식: 010으로 시작하고, 뒤에 4자리 숫자 2개
        const regex = /^010\d{4}\d{4}$/;
      
        return regex.test(cleaned);
    },
    isValidName: function(name) {
        // const regex = /^(?:[가-힣]{2,10}|[A-Za-z ]{2,50})$/;
        const regex = /^(?:[가-힣]+|[A-Za-z ]+)$/;
        return regex.test(name);
    }      
}



// WEBPACK FOOTER //
// ./src/utilities/validation.js